import React from "react";
import { AlertCircle, CheckCircle, X } from "lucide-react";

const NotificationPopup = ({ notification, hideNotification }) => {
    if (!notification) return null;

    const getNotificationStyles = () => {
        const baseStyles = "fixed top-6 right-6 z-50 max-w-md p-4 rounded-lg shadow-lg border transition-all duration-300 ease-in-out";
        
        switch (notification.type) {
            case 'success':
                return `${baseStyles} bg-green-50 border-green-200 text-green-800`;
            case 'error':
                return `${baseStyles} bg-red-50 border-red-200 text-red-800`;
            case 'info':
                return `${baseStyles} bg-blue-50 border-blue-200 text-blue-800`;
            default:
                return `${baseStyles} bg-gray-50 border-gray-200 text-gray-800`;
        }
    };

    const getIcon = () => {
        switch (notification.type) {
            case 'success':
                return <CheckCircle className="w-5 h-5 text-green-600" />;
            case 'error':
                return <AlertCircle className="w-5 h-5 text-red-600" />;
            case 'info':
                return <AlertCircle className="w-5 h-5 text-blue-600" />;
            default:
                return <AlertCircle className="w-5 h-5 text-gray-600" />;
        }
    };

    return (
        <div className={getNotificationStyles()}>
            <div className="flex items-start">
                <div className="mr-3 mt-0.5">
                    {getIcon()}
                </div>
                <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium break-words">
                        {notification.message}
                    </p>
                </div>
                <button
                    onClick={hideNotification}
                    className="ml-3 text-gray-400 hover:text-gray-600 transition-colors"
                >
                    <X className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
};

export default NotificationPopup;